(function () {
  'use strict';

  var section = document.querySelector('.odms26summer-alumni');
  if (!section) return;

  var prevBtn = section.querySelector('.odms26summer-alumni__arrow--prev');
  var nextBtn = section.querySelector('.odms26summer-alumni__arrow--next');
  var cards = section.querySelectorAll('.odms26summer-alumni__card');
  if (!prevBtn || !nextBtn || !cards.length) return;

  var currentIndex = 0;
  var maxVisible = window.innerWidth <= 640 ? 1 : 2;

  for (var i = 0; i < maxVisible && i < cards.length; i++) {
    cards[i].style.display = 'flex';
  }

  prevBtn.addEventListener('click', function () {
    if (currentIndex > 0) {
      cards[currentIndex + maxVisible - 1].style.display = 'none';
      currentIndex--;
      cards[currentIndex].style.display = 'flex';
    }
  });

  nextBtn.addEventListener('click', function () {
    if (currentIndex < cards.length - maxVisible) {
      cards[currentIndex].style.display = 'none';
      currentIndex++;
      cards[currentIndex + maxVisible - 1].style.display = 'flex';
    }
  });
})();
